import React from "react";

const ShowAddress = ({ shippingDetails }) => {
  return (
    <div style={{ width: "100%", textTransform: "capitalize" }}>
      <h4 style={{ marginBottom: "10px" }}>Your Current Shipping Address</h4>
      <div className="single_details_border">
        <p>
          <span className="shipping_title_indi">Name: </span>
          {shippingDetails.name}
        </p>
        <p>
          <span className="shipping_title_indi">Mobile: </span> 
          {shippingDetails.mobile}
        </p>
        <p>
          <span className="shipping_title_indi">Country: </span>
          {shippingDetails.country}
        </p>
        <p>
          <span className="shipping_title_indi">City: </span>
          {shippingDetails.city}
        </p>
        <p>
          <span className="shipping_title_indi">House Holding No: </span>
          {shippingDetails.house || "not given"}
        </p>
        <p>
          <span className="shipping_title_indi">Postal Code: </span>
          {shippingDetails.postalCode}
        </p>
      </div>
    </div>
  );
};

export default ShowAddress;
